export const LF_MASTER_LOGO_URL = 'https://lf-master-project-logos-prod.s3.us-east-2.amazonaws.com/test-project-group.svg';
export const CACHE_PATTERNS = {
  PUBLIC_MEETINGS: (slug: string) => `public_meetings_${slug}_*`,
  PUBLIC_PAST_MEETINGS: (slug: string) => `public_past_meetings_${slug}_*`,
  PUBLIC_PROJECT_COMMITTEES: (slug: string) => `public_project_committees_${slug}_*`,
};

// Identifiers (slug or project id) for projects whose meetings redirect to the LFX V2 UI.
// Upstream `ZoomMeeting.project` may be either form, so both are listed.
// Resolved from the prod project tree: batch 1 on 2026-09-22, batch 2 on 2026-09-29,
// batch 3 on 2026-10-14.
// A foundation's sub-projects are listed with it. Remove a foundation's block to roll
// that foundation back.
// Mirrored in apps/v1-backend zoom.service.ts — keep in sync.
export const V2_UI_REDIRECT_PROJECTS = [
  // ---- Batch 1 (PCC-1488) ----
  // Already live
  'lfproducts',
  'a092M00001KWlLeQAL',
  'agentic-ai-foundation',
  'lfZA9uadMdkwBqqHsj',
  // InterUSS Platform Fund + InterUSS Platform
  'interuss',
  'a092M00001IfXneQAF',
  'interuss-platform',
  'a092M00001KWeXKQA1',
  // Real-Time Linux
  'real-time-linux',
  'a0941000002wByzAAE',
  // OpenHPC Project
  'openhpc',
  'a0941000002wByrAAE',
  // TODO Group
  'todogroup',
  'a0941000002wBzFAAU',
  // OCUDU Ecosystem Foundation + OCUDU
  'ocudu-ecosystem-foundation',
  'lfLvL3wqaIcYwnl0M3',
  'ocudu',
  'lfbZCRSOhOnoykkHlp',
  // Automated Compliance Tooling (ACT). Prod stores the slug as both "ACT" and "act".
  'ACT',
  'act',
  'a092M00001GkhBlQAJ',
  'decoder-ring',
  'a092M00001IkWSyQAN',
  'fossology',
  'a0941000002wByXAAU',
  'ort',
  'a092M00001KWg3xQAD',
  'qmstr',
  'a092M00001KWfpbQAD',
  'spdx-tools',
  'a092M00001KWgUoQAL',
  'tern',
  'a092M00001JWskMQAT',
  // Jupyter Foundation
  'jupyter-foundation',
  'lfx8PfPcaAAbevANl3',
  // Open Insurance Data Standard Foundation (OPENIDS)
  'openids-foundation',
  'a092M00001IkN2LQAV',
  // x402 Foundation + x402
  'x402-foundation',
  'lfXoAq207KdyoiL9B9',
  'x402-protocol',
  'lflwn5pn9dM7e5slp9',
  // ---- Batch 2 ----
  // Continuous Delivery Foundation (CDF)
  'cdf',
  'a092M00001G3xhxQAB',
  'cdevents',
  'a092M00001L1C2OQAV',
  'cdf-binary-project',
  'a092M00001KWedTQAT',
  'cicd-cybersecurity',
  'lfPIu0Ig41nudtLP2F',
  'jayex',
  'a092M00001JWs5nQAD',
  'jenkins',
  'a092M00001JWr87QAD',
  'cdf-ortelius',
  'a092M00001KWhApQAL',
  'cdf-screwdriver',
  'a092M00001JWs5xQAD',
  'cdf-spinnaker',
  'a092M00001JWs5jQAD',
  // Sylva Fund. Prod slugs are "egate" (fund) and "egatefund" (project) — not "sylva".
  'egate',
  'a092M00001KjOrfQAF',
  'egatefund',
  'a092M00001L16ZLQAZ',
  // LF Edge
  'lfedge',
  'a092M00001EzWy7QAF',
  'akraino',
  'a0941000017365ZAAQ',
  'baetyl',
  'a092M00001JWr82QAD',
  'project-eve',
  'a092M00001IV4DuQAL',
  'edgelake',
  'lfV6tQfZWK1mJ97Kxz',
  'edgex',
  'a0941000005osNnAAI',
  'secure-device-onboard',
  'a092M00001IkZJkQAN',
  'fledge',
  'a092M00001JWskWQAT',
  'hedge',
  'a092M00001IfRAUQA3',
  'infiniedge-ai',
  'lfonKmNuDxlGfE4GbK',
  'instantx',
  'lfgatgyqBS2uBCAB7y',
  'nanomq',
  'lfHLJOgoBU33bj0kpp',
  'nexoedge',
  'lfJCtZGvt0d7GUd3jC',
  'ocre',
  'lfTgWfKLdePBZeUG4F',
  'open-horizon',
  'a092M00001IkZJfQAN',
  'alvarium',
  'a092M00001IkOXAQA3',
  'sote',
  'a092M00001IkOXnQAN',
  'ogec', // nested under State of the Edge
  'a092M00001IV4W3QAL',
  'ekuiper',
  'a092M00001KWur6QAD',
  // Cloud Foundry Foundation (CFF)
  'cloud-foundry',
  'a092M00001IkUMrQAN',
  'admin-and-legacy-cff',
  'a092M00001NWO5MQAX',
  'apprundep',
  'a092M00001NWO4sQAH',
  'app-runtime-interfaces',
  'a092M00001NWO4xQAH',
  'app-runtime-platform',
  'a092M00001NWO52QAH',
  'cffbin',
  'a092M00001LkKVZQA3',
  'cloud-foundry-on-kubernetes',
  'a092M00001NWO57QAH',
  'concourse-wg',
  'lfom0merlCpVmu8t8o',
  'foundational-infrastructure',
  'a092M00001NWO5CQAX',
  'bosh', // nested under Foundational Infrastructure WG
  'a092M00001IbM3gQAF',
  'paketo',
  'a092M00001LkG7bQAF',
  'service-management',
  'a092M00001NWO58QAH',
  'cff-open-service-broker-api-pmc', // nested under Service Management WG
  'a092M00001JWsMUQA1',
  'vulnerability-management-working-group',
  'a092M00001NWO5HQAX',
  // OpenWallet Foundation
  'openwalletfoundation',
  'a092M00001L18DzQAJ',
  'owf-aca-py',
  'lf0DmMTjlf1WtxauK7',
  'apostille',
  'lfW3zFWz5qCOEuamKU',
  'credo',
  'lfgDQVxG6aTebOZJav',
  'owf-didcomm-mediator-service',
  'lfJNysYDPtFsnyplp7',
  'ehr-wallet',
  'lfza6zO9ScakgMfOj5',
  'eudiplo',
  'lf7hzLh0zC67Zq0on0',
  'farmworker-wallet-os',
  'lfwSQGSdSs0LvlCSFy',
  'kapunsdk',
  'lfXnKj2RjypXr55iFz',
  'multi-format-vc-for-ios',
  'lfdDpLJWXdO5kJMWz2',
  'mdoc',
  'a092M00001MtdL1QAJ',
  'sd-jwt-net',
  'lf8Xa7J4BRsjI9Linx',
  'sd-jwt-javascript',
  'lf1y9k3cIl5PqDygcc',
  'sd-jwt-python-reference-implementation',
  'a092M00001MtBQBQA3',
  'sd-jwt-rust',
  'lfMbpw44DkWR4mPj2n',
  'trs',
  'lfptNhnaSv3RRv6qRJ',
  'thunderid',
  'lfrVUl1zCGXkn1dWIq',
  'tuvali',
  'lfID6CT85GrLRT6bFa',
  'vc-api',
  'lfZ3CuN7sFILTEEHvc',
  'vc-profile-validator',
  'lfCCdiOMXq2becI4dW',
  'vcx',
  'lfiVup5FAsVbGqmUQH',
  // OpenChain Project
  'openchain',
  'a0941000002wBypAAE',
  // ---- Batch 3 ----
  // LF Energy (LFE)
  'lfenergy',
  'a094100001Cb6HaAAJ',
  'energnn',
  'lf5aEYe6coFhjFY7X4',
  'lf-energy-ai-sig',
  'lfJZDTtwe7PzYugoTH',
  'ainetus',
  'lfeNXPuYxVK2CRNwbZ',
  'arras',
  'a092M00001L1HmTQAV',
  'assetlife',
  'lfa41EPKWxFl60ZGdB',
  'battery-data-alliance',
  'lfomTQpTLl3A7cDHjh',
  'cupid',
  'lfwN2bdbqmNgG2TtYc',
  'citrineos',
  'lfggfffNJIAO3ySYf9',
  'citylearn',
  'lfp8rrlK6FDsO9wk2q',
  'compas',
  'a092M00001IkJTLQA3',
  'dynawo',
  'a092M00001NYCPZQA5',
  'everest',
  'a092M00001LkEVlQAN',
  'edge-interop-flex-sig',
  'lf4h91oxXEK4GQJnaj',
  'fidopower',
  'a092M00001NYCPUQA5',
  'fledgepower',
  'a092M00001KWhUTQA1',
  'flexmeasures',
  'a092M00001LkH4sQAF',
  'geisa',
  'lf9JyPreYpr2H4waXR',
  'lfenergy-grid-simulation-and-modeling-sig',
  'lfeQFSWBGgyaXAeg4r',
  'gridvantage',
  'lfYw7SMxNrSMczS0vr',
  'grid2op',
  'lfa2ShNF11eLkCwHDn',
  'hyphae',
  'a092M00001KWhUOQA1',
  'global-granular-certificate-registry',
  'lfGakS2hWkgslRD2Rt',
  'lfe-sef',
  'lf3FcUytWThvGvfPAw',
  'lf-energy-standards-and-specifications',
  'a092M00001NVDPsQAP',
  'node-collective',
  'lfteqdawq12KhVQ5JD',
  'ores-open-renewal-energy-systems',
  'lfn16C1T8IdKmEtdUv',
  'ospo-sig',
  'lf98LDH2hPPR6szysc',
  'opendsm',
  'a092M00001IV4IkQAL',
  'opengridfm',
  'lfGFeSdSUJqLdBHTBZ',
  'openleadr',
  'a092M00001IV4IuQAL',
  'openstef',
  'a092M00001LkC68QAF',
  'opensynth',
  'lfKqhzuw4MXzjV5tBN',
  'operator-fabric',
  'a092M00001If869QAB',
  'powsybl',
  'lfDVCEHOD7BbGCdYoI',
  'powergridmodel',
  'a092M00001NYCPLQA5',
  'swamp',
  'lfryrBxQdUeK7djCSB',
  'project-origin',
  'a092M00001MtL0vQAF',
  'rtc-tools',
  'lfFMWLlIxeAyyEMxlU',
  'rtdip',
  'a092M00001L1HmxQAF',
  'seapath',
  'a092M00001IkWmNQAV',
  'sogno',
  'a092M00001IkV6jQAF',
  'shapeshifter',
  'a092M00001KWtA7QAL',
  'smart-hems-benchmark',
  'lfmCFnNe5hmZCBSF2C',
  'varen',
  'lfxOWgR2bjELnOxqrk',
  'covxtreme',
  'lfwTZTl5McN9ojiuC7',
  // Academy Software Foundation (ASWF)
  'aswf',
  'a09410000182dD2AAI',
  'opentimelineio-binary-project',
  'lfVhqnbkPAmm5xy7VW',
  'aces',
  'lfXJcd7sytTjCn40g9',
  'aswf-continuous-integration-wg',
  'a092M00001KWjDLQA1',
  'dailies-notes-assistant',
  'lfggVZllmLaTYZFChi',
  'dpel',
  'a092M00001Lk6x8QAB',
  'aswf-diversity-inclusion-wg',
  'a092M00001KWjDZQA1',
  'aswf-machine-learning-working-group',
  'lfctsPHvInHjg6hWSH',
  'materialx',
  'a092M00001KWrdoQAD',
  'moonray',
  'lfaDrcxHo8MzJFIMzN',
  'openpgl',
  'lfYjuePa6OtmW5KjGs',
  'openrv',
  'lfbkTM2SDFcVI6Okq1',
  'open-review-initiative',
  'a092M00001L1EL3QAN',
  'open-shading-language',
  'a092M00001IkWtEQAV',
  'openapv',
  'lfGqZxGXF1gkJmn1Un',
  'openassetio',
  'a092M00001L17vCQAR',
  'opencolorio',
  'a092M00001If9v8QAB',
  'opencue',
  'a092M00001IV3znQAD',
  'openexr',
  'a092M00001If9ujQAB',
  'openfx',
  'a092M00001MSuGfQAL',
  'openimageio',
  'a092M00001MtJNPQA3',
  'openqmc',
  'lfFn5GZ7ccsXkcmxHC',
  'open-timeline-io',
  'a092M00001If9uZQAR',
  'openvdb',
  'a092M00001If9vIQAR',
  'rez',
  'a092M00001LkM0JQAV',
  'rongotai-model-train-club-rmtc',
  'lfVbn6YwcC4WwCLufz',
  'aswf-usd-wg',
  'a092M00001KWjDUQA1',
  'wayland-for-artists',
  'lfZ7o5xUjoaFeVfvsf',
  'aswf-zero-trust-wg',
  'lf06ycC7yskev1oAsa',
  'rawtoaces',
  'a092M00001LkKVeQAN',
  'xstudio',
  'lfwQ4NyydjBcDCKMwn',
  // Linux Foundation Europe. Sylva Fund ("egate") and OpenWallet Foundation
  // ("openwalletfoundation") are sub-projects already listed from batch 2.
  'lfeurope',
  'a092M00001KWzi6QAD',
  'carbyne-stack',
  'lfR9dVEbC2rEebcv6s',
  'lfe-lfeu-df',
  'lfD0FztOb9RS3qtFc4',
  'neonephos-foundation',
  'lfGnr1MCq2lbKUf6f7',
  'open-crypto-broker',
  'lfpSIlrS0guboGTaRG',
  'open-software-development-initiative-for-risc-v-ecosystem',
  'a092M00001NW8mNQAT',
  'servo-llc',
  'a092M00001IkZR0QAN',
  // Camara Fund + Camara Project
  'camarafund',
  'a092M00001MtYMaQAN',
  'telcoapi',
  'a092M00001KWykQQAT',
  // OpenJS Foundation
  'ojsf',
  'a0941000002wBygAAE',
  'ojsf-amp',
  'a092M00001IkZIwQAN',
  'ojsf-appium',
  'a092M00001IV4FWQA1',
  'ojsf-arc',
  'a092M00001IV4FbQAL',
  'cosmos',
  'lfCa6T7LZuwZhtN8pb',
  'ojsf-dojo',
  'a092M00001IV4FgQAL',
  'ojsf-eslint',
  'a092M00001IV4FlQAL',
  'ojsf-electron',
  'a092M00001IkZIrQAN',
  'esprima',
  'a092M00001IV4FvQAL',
  'ojsf-express',
  'a092M00001IV4HIQA1',
  'osjf-fastify',
  'a092M00001IkOXhQAN',
  'geoda',
  'lfoQcuR2GEVTRYsdnS',
  'ojsf-globalize',
  'a092M00001IV4G0QAL',
  'ojsf-grunt',
  'a092M00001IV4G5QAL',
  'ojsf-hr',
  'a092M00001IV4GAQA1',
  'interledger-js',
  'a092M00001IV4GFQA1',
  'ojsf-intern',
  'a092M00001IV4GKQA1',
  'ojsf-json',
  'a092M00001MSufpQAD',
  'jerryscript',
  'a092M00001IV4GPQA1',
  'jest',
  'a092M00001NVRJCQA5',
  'lodash',
  'a092M00001IV4EyQAL',
  'loopback',
  'a092M00001Lk9RZQAZ',
  'marko',
  'a092M00001IV4GUQA1',
  'ojsf-mocha',
  'a092M00001IV4GZQA1',
  'ojsf-moment',
  'a092M00001IV4GeQAL',
  'ojsf-nativescript',
  'a092M00001IkZImQAN',
  'node-red',
  'a092M00001IV4GjQAL',
  'ojsf-nodejs',
  'a092M00001IV4HSQA1',
  'ojsf-qunit',
  'a092M00001IV4GtQAL',
  'ucf-project',
  'a092M00001KWiM2QAL',
  'ojsf-webdriver',
  'a092M00001IV4GyQAL',
  'webpack',
  'a092M00001IV4H8QAL',
  'ojsf-jquery',
  'a092M00001IV4DqQAL',
  'messageformat',
  'a092M00001IV4HNQA1',
  'ojsf-nvm',
  'a092M00001IkZInQAN',
  'visgl',
  'a092M00001KWfCjQAL',
  'ojsf-webhint',
  'a092M00001IV4H3QAL',
];

export function getV2UiBaseUrl(hostname?: string): string {
  const resolvedHostname = hostname ?? (typeof window !== 'undefined' ? window.location.hostname : '');

  if (resolvedHostname === 'localhost' || resolvedHostname.startsWith('127.') || resolvedHostname.includes('.dev.')) {
    return 'https://app.dev.lfx.dev';
  }
  if (resolvedHostname.includes('.staging.')) {
    return 'https://app.staging.lfx.dev';
  }
  return 'https://app.lfx.dev';
}
